import { useUpdateLabs } from '@/hooks/use-update-labs';
import { ChangeEvent, useState } from 'react';
import { toast } from 'react-toastify';

const UpdateLabs = () => {
    const { updateLabs, processLabResults } = useUpdateLabs();
    const [requisition, setRequisition] = useState('');

    const handleRequisitionChange = (e: ChangeEvent<HTMLInputElement>) => {
        setRequisition(e.currentTarget.value);
    };

    const handleUpdateRequisition = () => {
        updateLabs(requisition)
            .then(response => {
                if (response.ok) {
                    toast.success('Successfully updated lab requisition')
                } else {
                    toast.error('Unable to update lab requisition');
                }
            })
            .catch(() => {
                toast.error('Request failed');
            });
    };

    const handleProcessResults = () => {
        processLabResults(requisition.trim())
            .then(response => {
                if (response.ok) {
                    toast.success('Successfully updated lab results')
                } else {
                    toast.error('Unable to update lab results');
                }
            })
            .catch(() => {
                toast.error('Request failed');
            });
    };

    return (
        <>
            <div className='pt-3 pb-3'>
                <div className='container'>
                    <h2>Update Labs</h2>

                    <div className="card">
                        <div className='card-body'>
                            <div className='card-title'>What does this page do?</div>
                            <ul>
                                <li><strong>Update Requisition</strong> - this will create the order at PWN; after this you should go to the PWN site and create the mock results</li>
                                <li><strong>Process Lab Results</strong> - this will pull the results from PWN and upload the PDF into our system</li>
                            </ul>
                        </div>
                    </div>
                    <br/>
                    <div className='form-group'>
                        <label>Enter the requisition # as provided by PWN:</label>
                        <input
                            type='text'
                            placeholder='####'
                            className='form-control'
                            value={requisition}
                            onChange={handleRequisitionChange} />
                    </div>
                    <button className="btn btn-primary" disabled={requisition == ''} onClick={handleUpdateRequisition}>Update Requisition</button>{' '}
                    <button className="btn btn-default" disabled={requisition == ''} onClick={handleProcessResults}>Process Lab Results</button>
                </div>
            </div>
        </>
    );
}

export default UpdateLabs;